<template>
  <b-row class="manager-fallback-package-setting">
    <b-col sm="12" lg="12" style="padding: 0" class="fallback-package-setting">
      <b-card class="mb-4 invoice-formula-card">
        <b-card-body class="invoice-formula-card-body p-0">
          <div class="container invoice-formula-container">
            <div class="row mb-3">
              <div class="col-md-12">
                <span style="font-weight: semi-bold; font-size: 20pt">{{ __('Invoice Formula') }}</span>
              </div>
            </div>
            <hr class="mt-1" />
            <div class="col-md-12 invoice-formula-form">
              <b-form-group>
                <b-row>
                  <b-col md="12" class="formula-table">
                    <b-form-input value="@short_year-INV-[10000 + @sales_number]" disabled></b-form-input>
                    <b-table-simple hover small responsive>
                      <thead>
                        <tr>
                          <th>{{ __('Variables') }}</th>
                          <th>{{ __('Description') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th>@sales_number</th>
                          <td>
                            {{
                              __(
                                'Total sales number. Starting from number 1 and increasing one by one based on the number of sales made.',
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th>@sales_number_per_form</th>
                          <td>
                            {{
                              __(
                                'The sale number for each form. It starts from number 1 and increases one by one with each sale made.',
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th>@day</th>
                          <td>
                            {{
                              __(
                                'The day value (2 digits) of the month when the sale is made. Example: The third day will produce the value 03.',
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th>@month</th>
                          <td>
                            {{
                              __(
                                'The value of the month (2 digits) in a given year when the sale was made. Example: The month of April will produce the value 04.',
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th>@short_year</th>
                          <td>
                            {{
                              __('The last 2 digits of the year when the sale is made. Example: 14 for the year 2014.')
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th>@full_year</th>
                          <td>{{ __('The full year value (4 digits) when the sale is made.') }}</td>
                        </tr>
                      </tbody>
                    </b-table-simple>
                  </b-col>
                </b-row>

                <b-row class="mt-5">
                  <b-col md="1" class="mt-2">
                    <label for="invoice_number_formula">{{ __('Formula') }}</label>
                  </b-col>
                  <b-col md="11">
                    <b-input-group class="mb-3">
                      <b-form-input
                        id="invoice_number_formula"
                        name="invoice_number_formula"
                        v-model="formData.invoice_number_formula"
                        :placeholder="__('Enter formula...')"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="primary" @click="tryFormula('sale')">
                          {{ __('Try Formula') }}
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-modal id="formula-test-modal" :title="__('Try Formula')" hide-footer>
                  <div class="form-group">
                    <label for="formula">{{ __('Formula') }}</label>
                    <b-form-input type="text" name="formula" v-model="formulaData.formula"></b-form-input>
                  </div>

                  <div class="form-group row" v-show="formulaData.isSale">
                    <div class="col-md-6">
                      <label for="sales_number">@sales_number</label>
                      <b-form-input type="text" name="sales_number" v-model="formulaData.sales_number"></b-form-input>
                    </div>
                    <div class="col-md-6">
                      <label for="sales_number_per_form">@sales_number_per_form</label>
                      <b-form-input
                        type="text"
                        name="sales_number_per_form"
                        v-model="formulaData.sales_number_per_form"
                      ></b-form-input>
                    </div>
                  </div>

                  <div class="form-group row" v-show="formulaData.isParticipant">
                    <div class="col-md-12">
                      <label for="participant_number">@participant_number</label>
                      <b-form-input
                        type="text"
                        name="participant_number"
                        v-model="formulaData.participant_number"
                      ></b-form-input>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-6">
                      <label for="day">@day</label>
                      <b-form-input type="text" name="day" v-model="formulaData.day"></b-form-input>
                    </div>
                    <div class="col-md-6">
                      <label for="month">@month</label>
                      <b-form-input type="text" name="month" v-model="formulaData.month"></b-form-input>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-6">
                      <label for="short_year">@short_year</label>
                      <b-form-input type="text" name="short_year" v-model="formulaData.short_year"></b-form-input>
                    </div>
                    <div class="col-md-6">
                      <label for="full_year">@full_year</label>
                      <b-form-input type="text" name="full_year" v-model="formulaData.full_year"></b-form-input>
                    </div>
                  </div>

                  <label for="result">{{ __('Result') }}</label>
                  <b-form-input
                    class="bg-white"
                    type="text"
                    name="result"
                    v-model="formulaData.result"
                    readonly
                  ></b-form-input>

                  <div class="mt-3 d-flex justify-content-end">
                    <b-button
                      variant="primary"
                      class="mr-2"
                      @click="tryFormulaButton()"
                      :disabled="!formulaData.formula.trim()"
                    >
                      {{ __('Try') }}
                    </b-button>
                    <b-button variant="secondary" @click="$bvModal.hide('formula-test-modal')">
                      {{ __('Close') }}
                    </b-button>
                  </div>
                </b-modal>
              </b-form-group>

              <b-row class="text-center mt-4">
                <b-col md="12">
                  <b-button type="button" variant="primary" @click="saveFormula" :disabled="processing">
                    <b-spinner variant="light" small v-if="processing"></b-spinner>
                    <span v-else>{{ __('Save') }}</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-alert :variant="success ? 'success' : 'danger'" v-if="message" show>
                {{ message }}
              </b-alert>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      processing: false,
      formData: {
        invoice_number_formula: '',
      },
      formulaData: {
        formula: '',
        sales_number: 0,
        sales_number_per_form: 0,
        participant_number: 0,
        day: 0,
        month: 0,
        short_year: '',
        full_year: 0,
        result: '',
        isSale: false,
        isParticipant: false,
      },
    };
  },

  mounted() {
    this.fetchFormula();
  },

  methods: {
    fetchFormula() {
      axios
        .get('/api/invoice_formula_settings')
        .then((response) => {
          if (response.data && response.data.data && response.data.data.settings) {
            this.formData.invoice_number_formula = response.data.data.settings.value || '';
          }
        })
        .catch((error) => {
          this.$bvToast.toast(error.response?.data?.message || 'Failed to load formula settings', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          });
        });
    },

    saveFormula() {
      this.processing = true;

      axios
        .put('/api/invoice_formula_settings', {
          invoice_number_formula: this.formData.invoice_number_formula,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast(response.data.message || 'Formula saved successfully', {
              title: 'Success',
              variant: 'success',
              solid: true,
            });
          } else {
            this.$bvToast.toast(response.data.message || 'Failed to save formula', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
          }
        })
        .catch((error) => {
          this.$bvToast.toast(error.response?.data?.message || 'Failed to save formula', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },

    tryFormula(type) {
      const date = new Date(Date.now() - Math.random() * 1e11);

      this.formulaData = {
        formula: this.formData.invoice_number_formula,
        sales_number: Math.floor(Math.random() * 1000) + 1,
        sales_number_per_form: Math.floor(Math.random() * 1000) + 1,
        participant_number: Math.floor(Math.random() * 1000) + 1,
        day: date.getDate().toString().padStart(2, '0'),
        month: (date.getMonth() + 1).toString().padStart(2, '0'),
        short_year: date.getFullYear().toString().slice(-2),
        full_year: date.getFullYear(),
        result: '',
        isSale: type === 'sale',
        isParticipant: type === 'participant',
      };

      this.$bvModal.show('formula-test-modal');
    },

    tryFormulaButton() {
      if (this.formulaData.formula.trim() === '') return;

      this.processing = true;

      axios
        .post('/api/try_formula', this.formulaData)
        .then((response) => {
          if (response.data && response.data.result) {
            this.formulaData.result = response.data.result;
          } else {
            this.$bvToast.toast('Invalid response format', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            });
          }
        })
        .catch((error) => {
          this.$bvToast.toast(error.response?.data?.message || 'An error occurred while processing the formula', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style>
.layout-sidebar-large .main-content-wrap {
  background-image: url('@/assets/images/form/form-bg-orange.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

@media only screen and (max-width: 360px) {
  .invoice-formula-card-body,
  .invoice-formula-container {
    padding: 0;
  }

  .invoice-formula-card {
    width: 285px;
  }

  .invoice-formula-form {
    padding: 0;
  }

  .layout-sidebar-large .main-content-wrap {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 768px) {
  .formula-table {
    padding-right: 0;
  }

  .invoice-formula-form {
    padding: 0;
  }
}

@media only screen and (max-width: 600px) {
  .invoice-formula-setting {
    width: 113% !important;
  }
}
</style>
